module.exports = __webpack_public_path__ + "static/Morandin_Manuel-6f6907cf49923ed28c0f2fe18dccc3cd.pdf";